import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/auth.css';
import { ArgoxLogo } from '../brand/ArgoxLogo';

export function AuthLayout({ eyebrow, title, description, children }: { eyebrow: string; title: ReactNode; description: string; children: ReactNode }) {
  return <main className="auth-page">
    <Link className="auth-logo" to="/"><ArgoxLogo /></Link>
    <section className="auth-card">
      <div className="auth-intro"><span>{eyebrow}</span><h1>{title}</h1><p>{description}</p></div>
      {children}
    </section>
    <p className="auth-foot">¿Necesitas ayuda? <a href="mailto:hola@argox.mx">Habla con nosotros</a></p>
  </main>;
}
